var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#heart)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8916 4.8982C16.5165 3.26619 13.5836 4.02779 12.0002 5.89554C10.4169 4.02779 7.48398 3.25712 5.1089 4.8982C3.84938 5.76861 3.05769 7.23742 3.00371 8.78783C2.87775 12.3057 5.97257 15.1255 10.6957 19.4503L10.7857 19.5319C11.4695 20.1575 12.522 20.1575 13.2058 19.5229L13.3047 19.4322C18.0279 15.1164 21.1137 12.2967 20.9968 8.77877C20.9428 7.23742 20.1511 5.76861 18.8916 4.8982ZM12.0902 18.0994L12.0002 18.19L11.9103 18.0994C7.62793 14.1916 4.80301 11.6076 4.80301 8.9873C4.80301 7.17395 6.1525 5.81394 7.9518 5.81394C9.33727 5.81394 10.6868 6.71155 11.1636 7.95369H12.8459C13.3137 6.71155 14.6632 5.81394 16.0487 5.81394C17.848 5.81394 19.1975 7.17395 19.1975 8.9873C19.1975 11.6076 16.3726 14.1916 12.0902 18.0994Z",
    fill: "#B4B5B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0a3458bfbe18d69d5887676104560db6.svg";
export { ForwardRef as ReactComponent };